module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.messages.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, _vm._l((_vm.messages), function(message) {
    return _c('p', [_vm._v(_vm._s(message))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71a9adc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderErrorList.vue
// module id = 938
// module chunks = 2